export default __webpack_public_path__ + "static/media/zonaStands_julio15.58746a31.jpg";